import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon, type IconType } from './Icon';

export type InputSize = 'sm' | 'md';

export const inputFieldClasses =
  'bg-surface-2 text-text-1 w-full rounded-[4px] border transition-colors outline-none ' +
  'border-stroke-1 focus:border-primary-9 focus:shadow-[0_0_0_2px_var(--color-primary-3)]';

export const inputSizeClasses: Record<InputSize, string> = {
  sm: 'text-xs px-2.5 py-1.5',
  md: 'text-[13px] px-3 py-2',
};

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  icon?: IconType;
  inputSize?: InputSize;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ icon, inputSize = 'md', className, ...rest }, ref) => {
    return (
      <div className={twMerge('relative w-full', className)}>
        {icon && (
          <Icon
            symbol={icon}
            className="text-text-3 pointer-events-none absolute top-1/2 left-2.5 h-3.5 w-3.5 -translate-y-1/2"
          />
        )}
        <input
          ref={ref}
          className={twMerge(inputFieldClasses, inputSizeClasses[inputSize], icon && 'pl-8')}
          {...rest}
        />
      </div>
    );
  },
);
Input.displayName = 'Input';
